import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { AuthService, User } from '@core';

import { AppSettingsService } from '@shared/services/settings/app-settings.service';

import { TwoFactorAuthQrCodeModalComponent } from '../two-factor-auth-qr-code/two-factor-auth-qr-code-modal.component';

@Component({
  selector: 'app-two-factor-auth-monitor',
  standalone: true,
  template: ``,
})
export class TwoFactorAuthMonitorComponent implements OnDestroy {
  private subs: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private auth: AuthService,
    private appSettings: AppSettingsService
  ) {
    this.subs.push(
      this.auth.user().subscribe(user => {
        if ('is2FAEnabled' in user) {
          this.checkUser(user);
        }
      })
    );
  }

  checkUser(user: User): void {
    if (user.is2FAEnabled) {
      return;
    }
    if (this.appSettings.getSettingsValue().two_factor_auth_required) {
      this.openModal(user);
    }
  }

  openModal(user: User) {
    this.dialog.open(TwoFactorAuthQrCodeModalComponent, {
      disableClose: true,
      data: { user, disableCancel: true },
      width: '80vw',
      height: '100vh',
      maxWidth: '80vw',
      maxHeight: '100vh',
      position: { right: '0' },
      panelClass: 'two-factor-auth-qr-code-modal',
      hasBackdrop: true,
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(value => value.unsubscribe());
  }
}
